import React from 'react'
import { Hero } from './Hero'
import { ExploreCourse } from './ExploreCourses'
import { AboutUs } from './AboutUs'
import {Partners} from './Partners'
export const Home = () => {
  return (
    <div>
      <Hero />
      <AboutUs />
      <ExploreCourse />
      {/* <Testimonials /> */}
      <Partners />
    </div>
  )
}
